var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.landingWrapper},[_c('vue-headful',{attrs:{"title":_vm.getPageTitle('Assignment Download')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }